export type FileFieldProps = {
  type: 'file';
  id: string;
  label: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  className?: string;
};

const FileField: React.FC<FileFieldProps> = ({ id, label, onChange }) => {
  const handleFileChange: React.ChangeEventHandler<HTMLInputElement> = (
    event,
  ) => {
    const files = event.target.files;
    if (!files) return;

    const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    const maxFileSize = 10 * 1024 * 1024; // 10 MB in bytes

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      if (!validTypes.includes(file.type)) {
        alert('Ungültiger Dateityp. Nur JPG, JPEG und PNG sind zulässig.');
        return;
      }

      if (file.size > maxFileSize) {
        alert('File is too large. Maximum size is 10 MB.');
        return;
      }
    }

    onChange(event);
  };

  return (
    <div className="relative">
      <label htmlFor={id}>{label}</label>
      <input
        type="file"
        multiple={true}
        id={id}
        name={id}
        className="w-full rounded-lg border-2 border-solid px-4 py-3 text-base tracking-wide text-[black] outline-[black]/10 transition-all hover:ring-2 hover:ring-primary focus:ring-2 focus:ring-primary focus:ring-offset-2"
        onChange={handleFileChange}
      />
    </div>
  );
};

export { FileField };
